import { InjectionToken } from '@angular/core';

/**
 * Carrier-supplied configuration for
 * {@link ProductFeatureUpgradeButtonComponent}. Provided by the hosting carrier
 * via {@link ProductFeatureUpgradeButtonModule.forRoot}, sourced from its
 * environment files (previously read from the Kameleoon `upgrade_journey` flag).
 */
export interface ProductFeatureUpgradeButtonConfig {
  /**
   * Compare-plans redirect target. May be relative (in-app router navigation)
   * or absolute (full-page navigation to an external origin). Unlike the former
   * Kameleoon value, this is a single URL: each carrier environment file
   * supplies the target for its own environment.
   */
  comparePlansUrl?: string;
}

/**
 * DI token carrying the {@link ProductFeatureUpgradeButtonConfig}. Injected
 * optionally by the button so that consumers which import the module without
 * {@link ProductFeatureUpgradeButtonModule.forRoot} still resolve the component
 * (the button simply skips its default redirect when no URL is configured).
 */
export const PRODUCT_FEATURE_UPGRADE_BUTTON_CONFIG =
  new InjectionToken<ProductFeatureUpgradeButtonConfig>(
    'PRODUCT_FEATURE_UPGRADE_BUTTON_CONFIG'
  );
